import ApiService from '@/services/core/api.service'

const ProductCategoryService = {
  async get (query) {
    return ApiService.get(`admin/product-categories?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/product-categories', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/product-categories/${payload.id}`, payload)
  }
}

export default ProductCategoryService
